import { render, staticRenderFns } from "./B2BDetailOsmake.vue?vue&type=template&id=3293a1b6"
import script from "./B2BDetailOsmake.vue?vue&type=script&lang=js"
export * from "./B2BDetailOsmake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports